// extracted by mini-css-extract-plugin
export default {"cardImage":"ColorCardSkeleton_cardImage__J-4l6","cardTitle":"ColorCardSkeleton_cardTitle__2kg5H","cardBtn":"ColorCardSkeleton_cardBtn__cc2D9"};